export default __webpack_public_path__ + "static/media/user-icon.151ff305.svg";